import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import type { Json } from "@/integrations/supabase/types";

export interface Banner {
  id: string;
  title: string;
  image_url: string;
  image_path: string;
  landscape_image_url: string | null;
  landscape_image_path: string | null;
  link_url: string | null;
  is_active: boolean;
  badge: string | null;
  badge_ar: string | null;
  headline_line1: string | null;
  headline_line1_ar: string | null;
  headline_line2: string | null;
  headline_line2_ar: string | null;
  subheadline: string | null;
  subheadline_ar: string | null;
  description: string | null;
  description_ar: string | null;
  cta_text: string | null;
  cta_text_ar: string | null;
  cta_link: string | null;
  banner_type: string | null;
  display_order: number;
  text_bg_opacity: number | null;
  show_butterflies: boolean | null;
  background_type: string | null;
  video_url: string | null;
  video_path: string | null;
  landscape_video_url: string | null;
  landscape_video_path: string | null;
  journey_content?: Json | null;
}

export const useBanners = () => {
  const [banners, setBanners] = useState<Banner[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchBanners = async () => {
    const { data, error } = await supabase
      .from('banners')
      .select('*')
      .eq('is_active', true)
      .order('display_order', { ascending: true });

    if (error) {
      console.log('Error fetching banners:', error.message);
      setLoading(false);
      return;
    }

    setBanners(data || []);
    setLoading(false);
  };

  useEffect(() => {
    fetchBanners();

    const channel = supabase
      .channel('banners-realtime')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'banners'
        },
        () => {
          fetchBanners();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  return { banners, loading };
};
